const blinds = (function () {
	'use strict';
	let nodes = document.querySelectorAll('.blinds__toggle');
	let highlighted = null;

	const methods = {};

	const flip = (item) => {
		let front = item.querySelector('.blinds__front');
		let back = item.querySelector('.blinds__back');
		let newSide, oldSide;

		if (back.hasAttribute('aria-hidden')) {
			oldSide = front;
			newSide = back;
		} else {
			newSide = front;
			oldSide = back;
		}

		newSide.removeAttribute('hidden');
		newSide.removeAttribute('aria-hidden');

		oldSide.hidden = true;
		oldSide.setAttribute('aria-hidden', true);
	}

	const removeHighlight = (item) => {
		flip(item);
		item.classList.remove('blinds__item--active');
		highlighted = null;
	};

	const highlight = (item) => {
		flip(item);

		item.classList.add('blinds__item--active');

		highlighted = item;
	};

	methods.init = () => {
		const blinds = Array.from(nodes);

		blinds.map((item) => {
			item.addEventListener('click', (e) => {
				e.preventDefault();
				if (highlighted != null) {
					if (item == highlighted) {
						removeHighlight(highlighted);
					} else {
						removeHighlight(highlighted);
						highlight(item);
					}
				} else {
					highlight(item);
				}
			})
			item.addEventListener('keypress', (e) => {
				if (e.code === 'Enter' || e.code === 'Space') {
					e.preventDefault();
					highlight(item);
				}
			})
		})
	}

	return methods;
})();

export default blinds;